module.exports = __webpack_public_path__ + "static/kazim-yardimci-dc9ef1d5ecc7fd8508a7826d6103a424.jpg";